export enum ProductStatus {
    NotActive,
    Active
}